(function(){
  "use strict";
  var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* — séquence d'ouverture — */
  var markReady = function(){ document.body.classList.add('ready'); };
  if (document.readyState === 'complete') markReady();
  else addEventListener('load', markReady);
  requestAnimationFrame(markReady);

  /* — révélations au scroll — */
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: .12 });
  document.querySelectorAll('.rv').forEach(function(el){ io.observe(el); });

  /* — nav collante — */
  var nav = document.getElementById('siteNav');
  function onScrollNav(){ if (nav) nav.classList.toggle('is-stuck', scrollY > 24); }
  onScrollNav();

  /* — parallaxe légère — */
  var layers = [].slice.call(document.querySelectorAll('.parallax'));
  var ticking = false;
  function frame(){
    var vh = innerHeight;
    layers.forEach(function(el){
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var off = (r.top + r.height/2 - vh/2) * parseFloat(el.dataset.speed || .04);
      el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
    });
    ticking = false;
  }
  addEventListener('scroll', function(){
    onScrollNav();
    if (!ticking && !reduce) { ticking = true; requestAnimationFrame(frame); }
  }, { passive: true });
  if (!reduce) frame();

  /* — menu mobile — */
  var drawer = document.getElementById('drawer');
  var burger = document.getElementById('burger');
  var drawerClose = document.getElementById('drawerClose');
  function setDrawer(on){
    if (!drawer) return;
    drawer.classList.toggle('on', on);
    document.body.classList.toggle('nav-open', on);
    if (burger) burger.setAttribute('aria-expanded', String(on));
    if (on) { var a = drawer.querySelector('a'); if (a) a.focus(); }
  }
  if (burger) burger.addEventListener('click', function(){ setDrawer(!drawer.classList.contains('on')); });
  if (drawerClose) drawerClose.addEventListener('click', function(){ setDrawer(false); burger && burger.focus(); });
  if (drawer) drawer.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ setDrawer(false); }); });
  addEventListener('keydown', function(e){ if (e.key === 'Escape' && drawer && drawer.classList.contains('on')) setDrawer(false); });

  /* — curseur maison — */
  if (!reduce && matchMedia('(hover:hover)').matches) {
    var cur = document.getElementById('cursor');
    if (cur) {
      var x = 0, y = 0, cx = 0, cy = 0;
      addEventListener('pointermove', function(e){ x = e.clientX; y = e.clientY; cur.classList.add('on'); }, { passive: true });
      addEventListener('pointerleave', function(){ cur.classList.remove('on'); });
      (function loop(){
        cx += (x - cx) * .18; cy += (y - cy) * .18;
        cur.style.transform = 'translate3d(' + (cx - 4.5) + 'px,' + (cy - 4.5) + 'px,0)';
        requestAnimationFrame(loop);
      })();
      document.addEventListener('pointerover', function(e){
        cur.classList.toggle('big', !!e.target.closest('a,button,.swatch,.card,input'));
      });
    }
  }

  /* — défilement doux pour les ancres internes — */
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href');
      if (!id || id.length < 2) return;
      var t;
      try { t = document.querySelector(id); } catch (err) { return; }
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  });

  /* ═══════════ PANIER AJAX ═══════════ */
  var cartCount = document.getElementById('cartCount');
  var cartTotal = parseInt((cartCount && cartCount.textContent) || '0', 10) || 0;

  function bumpCartCount(n){
    cartTotal = n;
    if (!cartCount) return;
    cartCount.textContent = cartTotal;
    cartCount.classList.toggle('on', cartTotal > 0);
    cartCount.classList.add('pop');
    setTimeout(function(){ cartCount.classList.remove('pop'); }, 500);
  }

  /* — bulle volante du bouton cliqué jusqu'à l'icône panier — */
  function flyToCart(originEl){
    var cartIcon = document.getElementById('cartBtn');
    if (reduce || !cartIcon || !originEl) return;
    var startRect = originEl.getBoundingClientRect();
    var endRect = cartIcon.getBoundingClientRect();
    var size = 16;

    var bubble = document.createElement('div');
    bubble.className = 'fly-bubble';
    bubble.style.width = size + 'px';
    bubble.style.height = size + 'px';
    bubble.style.transform = 'translate(' + (startRect.left + startRect.width/2 - size/2) + 'px,' + (startRect.top + startRect.height/2 - size/2) + 'px) scale(1)';
    bubble.style.opacity = '1';
    document.body.appendChild(bubble);

    var dx = endRect.left + endRect.width/2 - size/2;
    var dy = endRect.top + endRect.height/2 - size/2;

    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        bubble.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.25)';
        bubble.style.opacity = '0';
      });
    });

    var cleanup = function(){ if (bubble.parentNode) bubble.parentNode.removeChild(bubble); };
    bubble.addEventListener('transitionend', cleanup);
    setTimeout(cleanup, 900);
  }

  function addToCart(variantId, quantity, btn){
    if (!variantId) return;
    var label = btn ? btn.querySelector('span') : null;
    var before = label ? label.textContent : '';
    if (btn) btn.disabled = true;

    fetch(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
    .then(function(res){ return res.json(); })
    .then(function(){
      return fetch('/cart.js').then(function(r){ return r.json(); });
    })
    .then(function(cart){
      bumpCartCount(cart.item_count);
      if (btn) { btn.classList.add('is-added'); flyToCart(btn); }
      if (label) label.textContent = '✓ Ajouté';
    })
    .catch(function(){
      if (label) label.textContent = 'Réessayer';
    })
    .finally(function(){
      setTimeout(function(){
        if (label) label.textContent = before;
        if (btn) { btn.disabled = false; btn.classList.remove('is-added'); }
      }, 1400);
    });
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn.dataset.variantId, 1, btn);
  });

  var cartBtn = document.getElementById('cartBtn');
  if (cartBtn) {
    /* le lien pointe déjà vers /cart — pas d'interception nécessaire */
  }

  /* — formulaire produit : soumission via AJAX pour rester sur la page — */
  var pdpForm = document.getElementById('productForm');
  if (pdpForm) {
    pdpForm.addEventListener('submit', function(e){
      e.preventDefault();
      var select = document.getElementById('productVariantId');
      var qtyInput = document.getElementById('productQty');
      var btn = document.getElementById('addToCartBtn');
      var variantId = select ? select.value : null;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      addToCart(variantId, qty, btn);
    });
  }

  /* — sélecteur de variantes (produit) — */
  var variants = window.__PRODUCT_VARIANTS__ || [];
  var optionInputs = document.querySelectorAll('[data-option-selector]');
  if (optionInputs.length && variants.length) {
    function currentSelection(){
      var sel = [];
      var groups = {};
      optionInputs.forEach(function(input){
        if (input.checked) groups[input.name] = input.value;
      });
      Object.keys(groups).sort().forEach(function(k){ sel.push(groups[k]); });
      return sel;
    }
    function findVariant(){
      var sel = currentSelection();
      return variants.find(function(v){
        var opts = [v.option1, v.option2, v.option3].filter(function(o){ return o !== null && o !== undefined; });
        return opts.length === sel.length && opts.every(function(o, i){ return o === sel[i]; });
      });
    }
    function applyVariant(v){
      var select = document.getElementById('productVariantId');
      var btn = document.getElementById('addToCartBtn');
      var label = document.getElementById('addToCartLabel');
      if (!v) {
        if (btn) btn.disabled = true;
        if (label) label.textContent = 'Indisponible';
        return;
      }
      if (select) select.value = v.id;
      if (btn) btn.disabled = !v.available;
      if (label) label.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';

      var priceEl = document.querySelector('.pdp__info .d4');
      if (priceEl && v.price != null) {
        priceEl.textContent = (v.price / 100).toLocaleString('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }
    optionInputs.forEach(function(input){
      input.addEventListener('change', function(){ applyVariant(findVariant()); });
    });
  }

  /* — stepper quantité (page produit) — */
  document.addEventListener('click', function(e){
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (minus) {
      var i = document.getElementById('productQty');
      if (i) i.value = Math.max(1, (parseInt(i.value, 10) || 1) - 1);
    }
    if (plus) {
      var j = document.getElementById('productQty');
      if (j) j.value = (parseInt(j.value, 10) || 1) + 1;
    }
  });

  /* — stepper quantité (panier) : soumet le formulaire panier — */
  document.addEventListener('click', function(e){
    var m = e.target.closest('[data-cart-qty-minus]');
    var p = e.target.closest('[data-cart-qty-plus]');
    var target = m || p;
    if (!target) return;
    var row = target.closest('.cart-line');
    var input = row && row.querySelector('[data-cart-qty]');
    if (!input) return;
    var val = parseInt(input.value, 10) || 0;
    input.value = m ? Math.max(0, val - 1) : val + 1;
  });

  /* — galerie produit : vignettes — */
  document.querySelectorAll('[data-thumb]').forEach(function(t){
    t.addEventListener('click', function(){
      var full = t.dataset.full;
      var mainImg = document.querySelector('.pdp__main .ph__img');
      if (full && mainImg) mainImg.src = full;
    });
  });

  /* — palette du hero fusionné : clic sur une teinte → montre la diapositive déjà chargée pour ce produit — */
  var slideSwatches = [].slice.call(document.querySelectorAll('[data-swatch-target]'));
  var slides = [].slice.call(document.querySelectorAll('[data-slide]'));
  if (slideSwatches.length && slides.length) {
    function showSlide(index){
      slides.forEach(function(s){ s.classList.toggle('is-active', s.dataset.slide === String(index)); });
      slideSwatches.forEach(function(b){ b.classList.toggle('is-active', b.dataset.swatchTarget === String(index)); });
    }
    slideSwatches.forEach(function(btn){
      btn.addEventListener('click', function(){ showSlide(btn.dataset.swatchTarget); });
    });
  }
})();